/**
 * @desc these users are the old ones where they have seperate collections
 * users after these users will be in a new collection and will be handled differently
 * @type {Array}
 */
export const depreciatedUsers = ['ra', 'zg', 'witness', 'roh', 'crown']
